var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIonLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83828 13.75H5.625C4.63044 13.75 3.67661 13.3549 2.97335 12.6517C2.27009 11.9484 1.875 10.9946 1.875 10C1.875 9.00544 2.27009 8.05161 2.97335 7.34835C3.67661 6.64509 4.63044 6.25 5.625 6.25H7.78945M12.2105 6.25H14.375C15.3696 6.25 16.3234 6.64509 17.0267 7.34835C17.7299 8.05161 18.125 9.00544 18.125 10C18.125 10.9946 17.7299 11.9484 17.0267 12.6517C16.3234 13.3549 15.3696 13.75 14.375 13.75H12.1617M6.6043 10H13.4738",
    stroke: "black",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonLink);
export default __webpack_public_path__ + "static/media/ion_link.fffa65e0308a6aaa8316ed4a7c7246f1.svg";
export { ForwardRef as ReactComponent };